import { render, staticRenderFns } from "./ProductHo.vue?vue&type=template&id=31716be6"
import script from "./ProductHo.vue?vue&type=script&lang=js"
export * from "./ProductHo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports